<div class="unauthorized-container">
  <div class="unauthorized-content">
    <div class="icon">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="15" y1="9" x2="9" y2="15"/>
        <line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
    </div>
    <h1>Access Denied</h1>
    <p>You don't have permission to access this page.</p>
    <p class="role-info">Your current role: <strong>{{ currentRole }}</strong></p>
    <div class="actions">
      <button (click)="goBack()" class="btn btn-secondary">Go Back</button>
      <button (click)="goHome()" class="btn btn-primary">Go to Dashboard</button>
    </div>
  </div>
</div>
